var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',[_c('CoronaArticle')],1)],1),_c('CRow',[_c('CCol',[_c('CovidPushNotification')],1)],1),_c('CRow',[_c('CCol',[_c('Buttons')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }